export const EOSEndpoint = {
	generic: "GENERIC",
	serviceManagement: "SERVICE_MANAGEMENT",
	vehicleHealth: "VEHICLE_HEALTH",
	vehicleInfo: "VEHICLE_INFO",
	vehicleMaintenance: "VEHICLE_MAINTENANCE",
	vehicleManagement: "VEHICLE_MANAGEMENT",
	vehicleSubscription: "VEHICLE_SUBSCRIPTION",
} as const;

export type EOSEndpoint = (typeof EOSEndpoint)[keyof typeof EOSEndpoint];
